'use client';
function isOptionsGroup(item) {
  return "group" in item;
}

export { isOptionsGroup };
//# sourceMappingURL=is-options-group.mjs.map
